import useFieldFocus from '@v4/hooks/useFieldFocus'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import useParsedHtml from '@v4/hooks/useParsedHtml'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { COLUMN_WIDTH } from './HtmlBlock.const'
import useStyles from './HtmlBlock.styled'

export const useHtmlBlock = props => {
	const metaData = useSectionMetaData()
	const classes = useStyles({ ...props, metaData })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })

	const parsedHtml = useParsedHtml(metaData.html.metaValue)

	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	return [
		{
			classes,
			text: metaData.text?.metaValue,
			textConfig: metaData.text?.config,
			fullWidth: metaData.containerWidth?.metaValue === COLUMN_WIDTH.full,
			containerWidth: metaData.containerWidth?.metaValue,
			parsedHtml,
			textEditable,
			textKey: metaData.text?.tierKey,
			key: metaData.containerWidth?.metaValue || 'none',
		},
		{
			handleTextClick,
			handleTextChange,
		},
	]
}
